module.exports = "/_next/static/images/section-for-construction-mob-bf2ade151ace4433595bf993973bbb6f.png.webp";